import { laptopMaxXL, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const InputsRow = styled.div`
  display: flex;
  flex-direction: row;

  @media (${laptopMaxXL}) {
    flex-direction: column;
  }
`;

export const TabButton = styled.button<{ $selected: boolean }>`
  width: 100%;
  max-width: 180px;
  height: 54px;
  background-color: ${({ theme, $selected }) => ($selected ? theme.primary : theme.backgroundLighter)};
  color: ${({ theme, $selected }) => ($selected ? theme.white : theme.backgroundMid)};
  font-weight: 600;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;

  @media (${tabletMax}) {
    max-width: calc(50% - 5px);
  }
`;

export const TabRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 10px 0;
  flex-wrap: wrap;
`;

export const HeaderRight = styled.div`
  flex: 1;

  h5 {
    font-size: 16px;
    color: ${({ theme }) => theme.textDark};
  }
`;

export const HeaderLeft = styled.div`
  flex: 0 0 360px;
  display: flex;
  gap: 10px;

  .pp-button {
    max-width: 100px;
    height: 56px;
  }

  @media (${laptopMaxXL}) {
    flex: 0;
    max-width: 360px;
  }
`;

export default InputsRow;
